/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = {
  config: {
    transitionTime: 200,
    //ms
    AJAX_URL_PREFIX: 'fp-ajax-for-mobile-theme',
    numberOfAttemptsToLoadPage: 10,
    adLoadDelay: 500,
    headerHeight: 76,
    lazyLoadTimeout: 10,
    lazyLoadPreloadNScreens: 2,
    limitCriteoForInFeed: false
  },
  events: {},
  createEvents: function createEvents(types) {
    var _this = this;

    types.forEach(function (type) {
      _this.events[type] = document.createEvent('Event');

      _this.events[type].initEvent(type, true, true);
    });
  },
  getEventByName: function getEventByName(name) {
    return this.events[name];
  },
  addEvent: function addEvent(object, type, callback) {
    if (object == null || typeof object == 'undefined') return;

    if (object.addEventListener) {
      object.addEventListener(type, callback, false);
    } else if (object.attachEvent) {
      object.attachEvent("on" + type, callback);
    } else {
      object["on" + type] = callback;
    }
  },
  attachEventToLinks: function attachEventToLinks(nodes, callback) {
    for (var i = 0; i < nodes.length; i++) {
      var link = nodes[i];
      this.addEvent(link, 'click', callback);
    }
  },
  isExternalUrl: function isExternalUrl(url) {
    var domain = function domain(url) {
      return url.replace('http://', '').replace('https://', '').split('/')[0];
    };

    return domain(location.href) !== domain(url);
  },
  findParentByClassName: function findParentByClassName(elem, className) {
    while (elem.parentNode) {
      elem = elem.parentNode;
      if (new RegExp(className).test(elem.className)) return elem;
    }

    return null;
  },
  toggleMenuBtn: function toggleMenuBtn(elem) {
    if (elem.dataset.state === 'closed') {
      elem.setAttribute('data-state', 'opened');
    } else if (elem.dataset.state === 'opened') {
      elem.setAttribute('data-state', 'closed');
    }
  },
  closeMenuBtn: function closeMenuBtn(elem) {
    elem.setAttribute('data-state', 'closed');
  },
  closeSidebar: function closeSidebar() {
    document.querySelector('#sidebar').removeAttribute('open');
    var mask = document.querySelector('.-amp-sidebar-mask') || document.querySelector('.i-amphtml-sidebar-mask');
    if (mask) mask.style.display = 'none';
  },
  ajax: function ajax(url, success, error) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url);

    xhr.onload = function () {
      if (xhr.status === 200) {
        success(xhr.responseText);
      } else {
        if (error !== undefined) error(xhr.status);
      }
    };

    xhr.onerror = function () {
      if (error !== undefined) error(xhr.status);
    };

    xhr.send();
  },
  getContent: function getContent(url, callback, options) {
    //add 'fp-ajax-for-mobile-theme' to URL
    var ajaxUrl = this.addStrToUrl(url, this.config.AJAX_URL_PREFIX);
    options = options || {};
    options.url = url;
    var that = this;
    var callCounter = 0;

    function call(ajaxUrl) {
      that.ajax(ajaxUrl, function (content) {
        var holder = document.createElement('div');
        holder.innerHTML = content;
        var result = {};
        var mainCol = holder.querySelector('#slider .main-col');
        result.slide = mainCol.innerHTML;
        result.prev = mainCol.dataset.prevUrl;
        result.next = mainCol.dataset.nextUrl;
        result.type = mainCol.dataset.type;
        result.title = holder.querySelector('title').innerHTML;
        callback(result, options);
      }, function (err) {
        console.log('Network error occurred, url failed is ' + ajaxUrl + ' Code is ' + err);
        setTimeout(function () {
          if (callCounter >= that.config.numberOfAttemptsToLoadPage) {
            callback({
              slide: that.errorHtmlCode,
              title: "-"
            }, options);
            return;
          }

          call(ajaxUrl);
          callCounter++;
        }, 1000);
      });
    }

    call(ajaxUrl);
  },
  addStrToUrl: function addStrToUrl(url, str) {
    var link = document.createElement("a");
    link.href = url;
    var path = link.pathname;
    var needle = link.protocol + "//" + link.host + link.pathname;
    var replace = link.protocol + "//" + link.host + "/" + str + link.pathname;
    return url.replace(needle, replace);
  },
  historyApiSupport: !!(window.history && history.pushState),
  killContent: function killContent(parent, callback) {
    for (var i = 0; i < parent.children.length; i++) {
      var node = parent.children[i];
      node.style.opacity = 1;
      node.style.transition = 'opacity ' + this.config.transitionTime + 'ms linear';
      node.style.opacity = 0;
    }

    setTimeout(function () {
      parent.innerHTML = '';
      callback();
    }, this.config.transitionTime);
  },
  loaderHtml: '<div class="loader visible"></div>',
  removeClass: function removeClass(node, value) {
    var regex = new RegExp("^" + value + "$|^" + value + " | " + value + "$| " + value + " ", "g");
    var newClassName = node.className;
    newClassName = newClassName.replace(regex, ' ');
    newClassName = newClassName.replace(/  /g, ' ');
    newClassName = newClassName.replace(/^ | $/g, '');
    node.className = newClassName;
  },
  addClass: function addClass(node, value) {
    var regex = new RegExp(value);

    if (!regex.test(node.className)) {
      node.className = node.className + ' ' + value;
    }
  },
  setPageTitleAndSendGAEvent: function setPageTitleAndSendGAEvent(title) {
    //set title
    if (title) window.document.title = title; //set GA event

    window.ga('set', 'page', window.location.pathname);
    window.ga('send', 'pageview'); //update addThis

    this.updateAddThis(title);
  },
  shorter_number_js: function shorter_number_js(num) {
    var o = '';

    if (num < 1000) {
      o = num;
    } else if (num >= 1000 && num < 10000) {
      o = this.round(num / 1000, 1) + "k";
    } else if (num >= 10000 && num < 1000000) {
      o = this.round(num / 1000, 0) + "k";
    } else if (num >= 1000000 && num < 10000000) {
      o = this.round(num / 1000000, 1) + "M";
    } else if (num >= 10000000) {
      o = this.round(num / 1000000, 0) + "M";
    }

    return o;
  },
  round: function round(value, precision, mode) {
    //  discuss at: http://locutus.io/php/round/
    // original by: Philip Peterson
    var m, f, isHalf, sgn; // helper variables
    // making sure precision is integer

    precision |= 0;
    m = Math.pow(10, precision);
    value *= m; // sign of the number

    sgn = value > 0 | -(value < 0);
    isHalf = value % 1 === 0.5 * sgn;
    f = Math.floor(value);

    if (isHalf) {
      switch (mode) {
        case 'PHP_ROUND_HALF_DOWN':
          // rounds .5 toward zero
          value = f + (sgn < 0);
          break;

        case 'PHP_ROUND_HALF_EVEN':
          // rouds .5 towards the next even integer
          value = f + f % 2 * sgn;
          break;

        case 'PHP_ROUND_HALF_ODD':
          // rounds .5 towards the next odd integer
          value = f + !(f % 2);
          break;

        default:
          // rounds .5 away from zero
          value = f + (sgn > 0);
      }
    }

    return (isHalf ? value : Math.round(value)) / m;
  },
  updateShareCounter: function updateShareCounter(elements) {
    var _this2 = this;

    if (!elements || elements.length === 0) return;
    var url = elements[0].dataset.currentUrlEncoded;
    var min_value = elements[0].dataset.postTitle.length / 2;
    min_value = Math.round(min_value);
    this.ajax('http://graph.facebook.com/?id=' + url, function (dataStr) {
      var data = JSON.parse(dataStr);
      var counter = 0;

      if (data.share && data.share.share_count) {
        counter = data.share.share_count;
      }

      counter = counter > min_value ? counter : min_value;

      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        element.innerHTML = _this2.shorter_number_js(counter);
        element.parentNode.style.opacity = 1;
      }
    });
  },
  openShareBox: function openShareBox(url, title, facebookAppId) {
    this.closeShareBox();
    var overlay = document.createElement('div');
    overlay.className = 'lightbox-overlay lightbox';
    overlay.style.height = window.innerHeight + 'px';
    this.addEvent(window, 'resize', function () {
      overlay.style.height = window.innerHeight + 'px';
    });
    var sharelinks = document.createElement('div');
    sharelinks.className = 'share-links lightbox';
    sharelinks.innerHTML = this.shareHtml(url, title, facebookAppId);
    var closeBtn = document.createElement('div');
    closeBtn.className = 'close-wrpper-round lightbox';
    closeBtn.innerHTML = '<div class="btn-close"></div>';
    this.addEvent(closeBtn, 'click', this.closeShareBox);
    document.body.appendChild(overlay);
    document.body.appendChild(sharelinks);
    overlay.appendChild(closeBtn);
  },
  closeShareBox: function closeShareBox() {
    // console.log(55);
    var nodes = document.querySelectorAll('.lightbox');

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      node.parentNode.removeChild(node);
    }
  },
  shareHtml: function shareHtml(url, title, facebookAppId) {
    var smList = [{
      name: "facebook",
      propsCode: "data-param-app_id=\"".concat(facebookAppId, "\" data-param-href=\"").concat(url, "\" data-param-quote=\"").concat(title, "\"")
    }, {
      name: "gplus",
      propsCode: ""
    }, {
      name: "linkedin",
      propsCode: ""
    }, {
      name: "pinterest",
      propsCode: "data-param-description=\"".concat(title, "\"")
    }, {
      name: "twitter",
      propsCode: ""
    }, {
      name: "whatsapp",
      propsCode: ""
    }];
    var result = [];

    for (var i = 0; i < smList.length; i++) {
      var item = smList[i];
      result.push("<amp-social-share \n                width=\"60px\" \n                height=\"60px\" \n                type=\"".concat(item.name, "\" \n                data-param-text=\"").concat(title, "\" \n                data-param-url=\"").concat(url, "\"\n                ").concat(item.propsCode, "\n             ></amp-social-share>"));
    }

    return result.join(' ');
  },
  errorHtmlCode: "",
  loadMorePagination: function loadMorePagination(btn, url, parentNode, linkClickHandler, contentSelector) {
    btn.setAttribute('data-state', 'loading');
    url = this.addStrToUrl(url, this.config.AJAX_URL_PREFIX);
    var that = this;
    var callCounter = 0;

    function call(url) {
      that.ajax(url, function (content) {
        var holder = document.createElement('div');
        holder.innerHTML = content;
        holder.innerHTML = holder.querySelector(contentSelector).innerHTML;
        holder.className = 'paged';

        if (holder.querySelector('.space-for-fixed-header')) {
          holder.removeChild(holder.querySelector('.space-for-fixed-header'));
        }

        that.attachEventToLinks(holder.querySelectorAll('a'), linkClickHandler);
        btn.className = 'hidden';
        btn.setAttribute('data-state', 'dismissed');
        parentNode.appendChild(holder);
        parentNode.dispatchEvent(that.getEventByName('contentLoadedToSlide'));
      }, function (err) {
        console.log('Network error occurred, url failed is ' + url + ' Code is ' + err);
        setTimeout(function () {
          if (callCounter >= that.config.numberOfAttemptsToLoadPage) {
            btn.setAttribute('data-state', 'default');
            btn.innerHTML = btn.innerHTML + ' <div class="some-error">' + window.config.loadmore.errorMsg + '</div>';
            return;
          }

          call(url);
          callCounter++;
        }, 1000);
      });
    }

    call(url);
  },
  runVideoOnNewSlides: function runVideoOnNewSlides(slide) {
    var videoWrapper = slide.querySelector('.wpb_video_wrapper');

    if (videoWrapper) {
      var scripts = this.transormToScripts(videoWrapper.innerHTML);
      scripts.forEach(function (script) {
        videoWrapper.appendChild(script);
      });
    }
  },
  runEmbedOnNewSlide: function runEmbedOnNewSlide(slide) {
    if (typeof twttr != 'undefined' && twttr.widgets && twttr.widgets.load) {
      twttr.widgets.load(slide);
    }

    var embedWrapper = slide.querySelector('.embed');

    if (embedWrapper) {
      var scripts = this.transormToScripts_v2(embedWrapper.innerHTML);
      scripts.forEach(function (script) {
        embedWrapper.appendChild(script);
      });
    }
  },
  transormToScripts: function transormToScripts(nodes) {
    var out = [];
    nodes = nodes.replace(/script\>[\s]+\<script/g, 'script><script');
    var div = document.createElement('div');
    div.innerHTML = nodes;
    var nodes = div.childNodes;

    for (var i = 0; i < nodes.length; i++) {
      var clone = nodeScriptClone(nodes[i]);
      if (typeof clone != 'undefined') out.push(clone);
    }

    function nodeScriptClone(node) {
      if (node.nodeName != 'SCRIPT') return;
      var script = document.createElement("script");
      script.text = node.innerHTML;

      if (node.attributes) {
        for (var i = node.attributes.length - 1; i >= 0; i--) {
          script.setAttribute(node.attributes[i].name, node.attributes[i].value);
        }
      }

      return script;
    }

    return out;
  },
  transormToScripts_v2: function transormToScripts_v2(nodes) {
    var out = [];
    nodes = nodes.replace(/script\>[\s]+\<script/g, 'script><script');
    var div = document.createElement('div');
    div.innerHTML = nodes;
    var nodes = div.querySelectorAll('script');

    for (var i = 0; i < nodes.length; i++) {
      var clone = nodeScriptClone(nodes[i]);
      if (typeof clone != 'undefined') out.push(clone);
    }

    function nodeScriptClone(node) {
      if (node.nodeName != 'SCRIPT') return;
      var script = document.createElement("script");
      script.text = node.innerHTML;

      if (node.attributes) {
        for (var i = node.attributes.length - 1; i >= 0; i--) {
          script.setAttribute(node.attributes[i].name, node.attributes[i].value);
        }
      }

      return script;
    }

    return out;
  },
  showCrossInCorner: function showCrossInCorner(url) {
    var cross = document.getElementById('cross-in-corner');
    cross.href = url;
    this.addEvent(cross, 'click', function () {
      cross.style.opacity = 0;
    });
    cross.style.display = 'block';
    setTimeout(function () {
      cross.style.opacity = 1;
    }, 500);
  },
  hideCrossInCorner: function hideCrossInCorner() {
    var cross = document.getElementById('cross-in-corner');
    cross.style.display = 'none';
    cross.style.opacity = 0;
  },
  updateAddThis: function updateAddThis(title) {
    var url = window.location.href.split("?")[0].replace(/\/[0-9]+\/$/, "/");
    title = title ? title : window.document.title;
    window.addthis_share = {
      url: url,
      title: document.title
    }; //Hide counter because we can't refresh it

    document.querySelector(".at-share-dock-outer a.at4-count").style.display = 'none'; //fix width of other share buttons

    var share_buttons = document.querySelectorAll(".at-share-dock-outer a.at-share-btn");
    var amount_of_buttons = share_buttons.length;
    var new_share_buttons_width = 100 / amount_of_buttons + '%';

    for (var i = 0; i < share_buttons.length; i++) {
      var share_button = share_buttons[i];
      share_button.style.width = new_share_buttons_width;
    } // console.log('updateAddThis', {url: url, title: title});

  },
  getViewportHeight: function getViewportHeight() {
    var doc = window.document,
        body = doc.body,
        html = doc.documentElement;
    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  },
  urlsBeforeHashAreEquals: function urlsBeforeHashAreEquals(url1, url2) {
    return this._getUrlBeforeHash(url1) === this._getUrlBeforeHash(url2);
  },
  getElementViewportOffset: function getElementViewportOffset(element) {
    var that = this;
    var viewportOffset = element.getBoundingClientRect();
    return {
      top: viewportOffset.top - that.config.headerHeight,
      bottom: viewportOffset.bottom - that.config.headerHeight
    };
  },
  isFacebookApp: function isFacebookApp() {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    return ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1;
  },
  blockScrollingOfMainWindow: function blockScrollingOfMainWindow() {
    this.addEvent(window, 'scroll', function () {
      window.scrollTo(0, 0);
    });
    this.addEvent(window, 'resize', function () {
      window.scrollTo(0, 0);
    });
    this.addEvent(window, 'orientationchange', function () {
      window.scrollTo(0, 0);
    });
  },
  _getUrlBeforeHash: function _getUrlBeforeHash(url) {
    return url.split('#')[0];
  }
};

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

// Ads
var ads = __webpack_require__(6);

ads.init(document.body); // AnotherSlideViewed

var anotherSlideViewed = __webpack_require__(9);

anotherSlideViewed.init(document.body);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var helper = __webpack_require__(0);

var FooterWidget = __webpack_require__(7);

var Utm = __webpack_require__(8);

Utm.storeUrlParams('utm_source');
Utm.storeUrlParams('utm_campaign');
Utm.storeUrlParams('utm_medium');
module.exports = {
  init: function init(pageContainer) {
    var that = this;
    that.addAds(pageContainer);
    helper.addEvent(document.body, 'thb_after_infinite_load', function () {
      that.addAds(this);
    }); //init ststic units

    this.addAds(document.getElementById('body_button_units'), undefined, true);
    var fp_bounce_popup = document.getElementById('fp_bounce_popup');
    if (fp_bounce_popup) this.addAds(fp_bounce_popup, undefined, true); // Handle fixed footer and interstical units

    googletag.cmd.push(function () {
      googletag.pubads().addEventListener('slotRenderEnded', function (dfpEvent) {
        var addUnitPath = dfpEvent.slot.getAdUnitPath();
        if (addUnitPath === window.config.footerUnitName) that.handleFooterUnit(dfpEvent); // if(addUnitPath === window.config.interstUnitName) that.handleInterstUnit(dfpEvent);
      });
    });
    var every = 4000;
    var goal = every;
    helper.addEvent(window, 'slideScrolling', function () {
      // let covered = 0;
      if (window.lastScrollTop >= goal) {
        goal = goal + every; // console.log('scrolled ' + every);

        if (that.dfpSlotsToRefresh.length) {
          var filteredSlots = that.dfpSlotsToRefresh.filter(function (slot) {
            var slotHeight = document.querySelector('#' + slot.getSlotElementId() + ' iframe').clientHeight; // console.log('slotHeight: ' + slotHeight);

            return slotHeight > 1;
          });

          if (filteredSlots.length) {
            that._refreshSlots(filteredSlots, that._getPrebidConfigForSlots(filteredSlots));
          }
        }
      }
    });
  },
  dfpSlotsIterator: 0,
  dfpSlots: [],
  dfpSlotsToRefresh: [],
  getRoxotSectorId: function getRoxotSectorId() {
    try {
      var storageKey = 'roxot-sid';
      var groupId = localStorage.getItem(storageKey);

      if (groupId === null) {
        groupId = 1 + Math.floor(Math.random() * 100);
        localStorage.setItem(storageKey, groupId);
      }

      return '' + groupId;
    } catch (e) {
      return '' + 101;
    }
  },
  getRoxotDeep: function getRoxotDeep() {
    try {
      var storageKey = 'roxot-deep';
      var groupId = localStorage.getItem(storageKey);

      if (groupId === null) {
        groupId = 1 + Math.floor(Math.random() * 100);
        localStorage.setItem(storageKey, groupId);
      }

      return '' + groupId;
    } catch (e) {
      return '' + 101;
    }
  },
  getRoxotEvent: function getRoxotEvent() {
    return '' + (1 + Math.floor(Math.random() * 100));
  },
  addAds: function addAds(container, direction, isFixedUnit) {
    var _this = this;

    var that = this;
    var adPlacements = that.getAdPlacementsWithinNScreensFromCurrent(container, helper.config.lazyLoadPreloadNScreens, direction, isFixedUnit);
    if (adPlacements.length == 0) return; // In case all adPlacements have div_added return now

    var amountOfAdPlacementsToProcess = 0;

    for (var i = 0; i < adPlacements.length; i++) {
      if (adPlacements[i].dataset.state !== "div_added") {
        amountOfAdPlacementsToProcess++;
      }
    }

    if (amountOfAdPlacementsToProcess < 1) return;
    var adsPortion = [];
    var dfpSlotsPortion = [];
    this.listenForScroll(container); //set placement iterator

    for (var _i = 0; _i < adPlacements.length; _i++) {
      var adPlacement = adPlacements[_i];
      if (adPlacement.dataset.state === "div_added") continue; // anchored-footer

      if (adPlacement.dataset.adPositionType == 'anchoredfooter') {
        window.fp_anchoredfooter_iterator = window.fp_anchoredfooter_iterator || 0;
        var iterator = window.fp_anchoredfooter_iterator;
        window.fp_anchoredfooter_iterator++;
        adPlacement.setAttribute('data-counter', iterator);
        adPlacement.setAttribute('data-ad-position-type-N', 'anchoredfooter_' + iterator);
        if (iterator > 100) adPlacement.setAttribute('data-ad-position-type-N', 'anchoredfooter_100_plus');
      } // in-content


      if (adPlacement.dataset.adPositionType == 'infeed') {
        window.fp_infeed_iterator = window.fp_infeed_iterator || 0;
        var _iterator = window.fp_infeed_iterator;
        window.fp_infeed_iterator++;
        adPlacement.setAttribute('data-counter', _iterator);
        adPlacement.setAttribute('data-ad-position-type-N', 'infeed_' + _iterator);
        if (_iterator > 100) adPlacement.setAttribute('data-ad-position-type-N', 'infeed_100_plus');
      } // separator


      if (adPlacement.dataset.adPositionType == 'separator') {
        window.fp_separator_iterator = window.fp_separator_iterator || 0;
        var _iterator2 = window.fp_separator_iterator;
        window.fp_separator_iterator++;
        adPlacement.setAttribute('data-counter', _iterator2);
        adPlacement.setAttribute('data-ad-position-type-N', 'separator_' + _iterator2);
        if (_iterator2 > 100) adPlacement.setAttribute('data-ad-position-type-N', 'separator_100_plus');
      } // sidebar


      if (adPlacement.dataset.adPositionType == 'rightslider') {
        window.fp_sidebar_iterator = window.fp_sidebar_iterator || 0;
        var _iterator3 = window.fp_sidebar_iterator;
        window.fp_sidebar_iterator++;
        adPlacement.setAttribute('data-counter', _iterator3);
        adPlacement.setAttribute('data-ad-position-type-N', 'rightslider_' + _iterator3);
        if (_iterator3 > 100) adPlacement.setAttribute('data-ad-position-type-N', 'rightslider_100_plus');
      }
    }

    var _loop = function _loop(_i2) {
      var adPlacement = adPlacements[_i2];
      if (adPlacement.dataset.state === "div_added") return "continue";
      var unitName = adPlacement.dataset.adunitName;
      var unitSizes = adPlacement.dataset.adunitSizes ? JSON.parse(adPlacement.dataset.adunitSizes) : undefined;
      var iterator = _this.dfpSlotsIterator++;
      var unitDivId = 'div-gpt-ad-' + iterator;
      var ad_position_type = adPlacement.dataset.adPositionType || 0;
      var ad_position_type_N = adPlacement.dataset.adPositionTypeN || 0;
      var ad_position_sidebar = adPlacement.dataset.adPositionSidebar || 0;
      var utm_source = void 0;

      if (window.fp_utm_source) {
        utm_source = window.fp_utm_source.replace(/[^A-Za-z0-9-_]/, '').substring(0, 40);
      } else {
        utm_source = 'Empty Value';
      } //add div with unic IDs


      adPlacement.setAttribute('data-state', 'div_added');
      adPlacement.innerHTML = "<div id=\"".concat(unitDivId, "\"></div>"); // save unit ids in global variable

      window.pageAdUnits = window.pageAdUnits || [];
      window.pageAdUnits.push({
        unitName: unitName,
        unitDivId: unitDivId
      });

      var prebidConfig = _this._getPrebidConfig(unitName, unitDivId);
      /* Getting consent cookie content */

      /*let consent = {
          1 : true,
          2 : true,
          3 : true,
          4 : true,
          5 : true
      };*/


      var consent = {
        1: false,
        // Accessing a Device : Allow storing or accessing information on a user’s device.
        2: false,
        // Advertising Personalisation : Allow processing of a user’s data to provide and inform personalised advertising (including delivery, measurement, and reporting) based on a user’s preferences or interests known or inferred from data collected across multiple sites, apps, or devices; and/or accessing or storing information on devices for that purpose.
        3: false,
        // Analytics : Allow processing of a user’s data to deliver content or advertisements and measure the delivery of such content or advertisements, extract insights and generate reports to understand service usage; and/or accessing or storing information on devices for that purpose.
        4: false,
        // Content Personalisation : Allow processing of a user’s data to provide and inform personalised content (including delivery, measurement, and reporting) based on a user’s preferences or interests known or inferred from data collected across multiple sites, apps, or devices; and/or accessing or storing information on devices for that purpose.
        5: false // Matching Data to Offline Sources : Combining data from offline sources that were initially collected in other contexts

      };

      function createCookie(name, value, seconds) {
        if (seconds) {
          var date = new Date();
          date.setTime(date.getTime() + seconds * 1000);
          var expires = "; expires=" + date.toGMTString();
          document.cookie = name + "=" + value + expires + "; path=/";
        } else {
          document.cookie = name + "=" + value + "; path=/";
        }
      }

      function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');

        for (var _i3 = 0; _i3 < ca.length; _i3++) {
          var c = ca[_i3];

          while (c.charAt(0) == ' ') {
            c = c.substring(1, c.length);
          }

          if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length, c.length);
          }
        }

        return null;
      }

      function eraseCookie(name) {
        createCookie(name, "", -1);
      }

      function cmpCallback(result) {
        var purposes = [];

        for (var _i4 = 1; _i4 <= 5; _i4++) {
          purposes[_i4] = result.standardPurposeConsents[_i4] ? 1 : 0;
        }

        document.cookie = "purposes=" + purposes.join(',').substr(1);
        eraseCookie("purposes");
        createCookie("purposes", purposes.join(',').substr(1), 2);
      }

      __cmp('getPublisherConsents', null, function (result) {
        return cmpCallback(result);
      });

      var nameEQ = "purposes=";
      var ca = document.cookie.split(';');
      var cookie = null;

      for (var _i5 = 0; _i5 < ca.length; _i5++) {
        var c = ca[_i5];

        while (c.charAt(0) == ' ') {
          c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEQ) == 0) {
          cookie = c.substring(nameEQ.length, c.length);
        }
      }

      if (cookie && cookie !== null) {
        var purposes = cookie.split(",");

        if (purposes !== null && purposes.length == 5) {
          for (var _i6 = 1; _i6 <= 5; _i6++) {
            consent[_i6] = purposes[_i6 - 1] == 1 ? true : false;
          }
        }
      } //define slots
      //display slots


      googletag.cmd.push(function () {
        var nameEQ = "purposes=";
        var ca = document.cookie.split(';');
        var cookie = null;

        for (var _i7 = 0; _i7 < ca.length; _i7++) {
          var _c = ca[_i7];

          while (_c.charAt(0) == ' ') {
            _c = _c.substring(1, _c.length);
          }

          if (_c.indexOf(nameEQ) == 0) {
            cookie = _c.substring(nameEQ.length, _c.length);
          }
        }

        if (cookie && cookie !== null) {
          var _purposes = cookie.split(",");

          if (_purposes !== null && _purposes.length == 5) {
            for (var _i8 = 1; _i8 <= 5; _i8++) {
              consent[_i8] = _purposes[_i8 - 1] == 1 ? true : false;
            }
          }
        }

        if (consent[2]) {
          // console.log("[DEBUG] DFP - consent ok");
          googletag.pubads().setRequestNonPersonalizedAds(0);
        } else {
          // console.log("[DEBUG] DFP - consent NOK");
          googletag.pubads().setRequestNonPersonalizedAds(1);
        }

        that.dfpSlots[iterator] = googletag.defineSlot(unitName, unitSizes, unitDivId).addService(googletag.pubads());
        that.dfpSlots[iterator].prebidConfig = prebidConfig; // if (ad_position_type) that.dfpSlots[iterator].setTargeting('ad_position_type', ad_position_type);

        if (ad_position_type_N) that.dfpSlots[iterator].setTargeting('ad_position_type_N', ad_position_type_N); // if (ad_position_sidebar) that.dfpSlots[iterator].setTargeting('ad_position_sidebar', ad_position_sidebar);
        // that.dfpSlots[iterator].setTargeting('utm_source', utm_source);

        if (window.config.utm_key) {
          var source = window.fp_utm_source || 'src-na';
          source = source.replace(/_/g, '-');
          var medium = window.fp_utm_medium || 'med-na';
          medium = medium.replace(/_/g, '-');
          var campaign = window.fp_utm_campaign || 'cmp-na';
          campaign = campaign.replace(/_/g, '-');
          var value = [source, medium, campaign].join('_').substring(0, 40);
          that.dfpSlots[iterator].setTargeting(window.config.utm_key, value);
        } // if(window.fp_utm_campaign) that.dfpSlots[iterator].setTargeting('utm_campaign', window.fp_utm_campaign);


        var matches = window.location.pathname.match(/\/([^\/]+)\/$/);

        if (matches !== null) {
          var post_slug = matches[1].substring(0, 40);
          that.dfpSlots[iterator].setTargeting('post_slug', post_slug);
        }

        var category_slug_dfp;

        if (window.category_slug_dfp) {
          category_slug_dfp = window.category_slug_dfp;
        } else {
          var post_detail = document.querySelectorAll('.post-detail')[0];
          category_slug_dfp = post_detail && post_detail.dataset.catSlugDfp;
          window.category_slug_dfp = category_slug_dfp;
        }

        if (category_slug_dfp) category_slug_dfp = category_slug_dfp.split('#');
        if (category_slug_dfp && category_slug_dfp.length === 1) category_slug_dfp = category_slug_dfp[0];
        if (category_slug_dfp) that.dfpSlots[iterator].setTargeting('category', category_slug_dfp); // 0-NPA, 1-PA

        if (consent[2]) {
          that.dfpSlots[iterator].setTargeting('gad-type', '1');
        } else {
          that.dfpSlots[iterator].setTargeting('gad-type', '0');
        } // Roxot code
        // if (consent) {


        that.dfpSlots[iterator].setTargeting('roxot-sector-id', that.getRoxotSectorId());
        that.dfpSlots[iterator].setTargeting('roxot-deep', that.getRoxotDeep());
        that.dfpSlots[iterator].setTargeting('roxot-event', that.getRoxotEvent()); // }

        googletag.display(unitDivId);
        dfpSlotsPortion.push(that.dfpSlots[iterator]); // Add footer unit in array to refresh

        if (unitName === window.config.footerUnitName) {
          // console.log('footer with name ' + unitName + ' added to array to refresh');
          that.dfpSlotsToRefresh.push(that.dfpSlots[iterator]);
        }
      });
      adsPortion.push({
        'adPlacement': adPlacement,
        'unitName': unitName,
        'unitDivId': unitDivId,
        'prebidConfig': prebidConfig
      }); // adPlacement.style.backgroundColor = '#f36c00';
    };

    for (var _i2 = 0; _i2 < adPlacements.length; _i2++) {
      var _ret = _loop(_i2);

      if (_ret === "continue") continue;
    } // Prepare prebid config


    var prebidUnitsConfig = adsPortion.map(function (ad) {
      if (ad.prebidConfig === undefined) return;
      var unitConfig = JSON.parse(JSON.stringify(ad.prebidConfig));
      unitConfig.code = ad.unitDivId;
      return unitConfig;
    });
    prebidUnitsConfig = prebidUnitsConfig.filter(function (item) {
      return item != undefined;
    }); // DFP part

    googletag.cmd.push(function () {
      googletag.pubads().enableSingleRequest();
      googletag.enableServices();
    });

    this._refreshSlots(dfpSlotsPortion, prebidUnitsConfig);
  },
  getAdPlacementsWithinNScreensFromCurrent: function getAdPlacementsWithinNScreensFromCurrent(container, distance, direction, isFixedUnit) {
    distance = distance || 3;
    direction = direction === undefined ? 'down' : direction;
    var result = [];
    var placements = container.querySelectorAll('.adPlacement');
    if (isFixedUnit) return placements;

    for (var i = 0; i < placements.length; i++) {
      var placement = placements[i];
      var viewportOffset = placement.getBoundingClientRect();
      var viewportHeight = window.document.documentElement.clientHeight;
      var offset = {
        top: viewportOffset.top - helper.config.headerHeight,
        bottom: viewportOffset.bottom - helper.config.headerHeight
      };
      var distanceToAd = void 0; // set distanceToAd

      if (direction === 'down') {
        distanceToAd = offset.top - viewportHeight;
      } else {
        distanceToAd = offset.bottom * -1;
      } // add placements to result


      var distanceToMiddleOfAd = parseInt(distanceToAd + placement.offsetHeight / 2);

      if (distanceToAd < viewportHeight * distance && distanceToMiddleOfAd > viewportHeight * -1) {
        // debug
        // placement.setAttribute('debug-lazy-load', '+');
        result.push(placement);
      } else {} // debug
      // placement.setAttribute('debug-lazy-load', '-');
      // console.log(direction, distanceToMiddleOfAd);

    }

    return result;
  },
  listenForScroll: function listenForScroll(container) {
    if (container.dataset.scrollListenerAttached === '1') return;
    container.setAttribute('data-scroll-listener-attached', '1');
    var that = this;
    var timer;
    var timeout = helper.config.lazyLoadTimeout;
    helper.addEvent(window, 'slideScrolledDown', function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        that.addAds(container, 'down');
      }, timeout);
    });
    helper.addEvent(window, 'slideScrolledUp', function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        that.addAds(container, 'up');
      }, timeout);
    });
  },
  handleFooterUnit: function handleFooterUnit(dfpEvent) {
    var _this2 = this;

    console.log('handleFooterUnit v5'); // Once height > 1 init();
    // after 500ms show();
    // check height every 1s and update widget height

    var showTimer = setInterval(function () {
      var creativeHeight = _this2.getHeightOfRenderedUnit(dfpEvent);

      var isEmpty = dfpEvent.isEmpty;

      if (!isEmpty && creativeHeight > 1) {
        FooterWidget.init(dfpEvent);
        setTimeout(function () {
          FooterWidget.show(dfpEvent);
          window.updateFooterHeightTimer = setInterval(function () {
            FooterWidget.updateHeight(dfpEvent);
          }, 1000);
        }, 500);
        clearInterval(showTimer);
      }

      if (isEmpty === true) {
        clearInterval(showTimer);
      } else if (isEmpty === false) {// good
      } else {
        console.warn('handleFooterUnit received unknown dfpEvent.isEmpty');
      }
    }, 500);
    setTimeout(function () {
      // let creativeHeight = (dfpEvent.size) ? dfpEvent.size[1] : undefined;
      var creativeHeight = _this2.getHeightOfRenderedUnit(dfpEvent);

      var isEmpty = dfpEvent.isEmpty;

      if (!isEmpty && creativeHeight <= 1) {
        FooterWidget.hide(dfpEvent);
      }

      if (isEmpty) {
        FooterWidget.hide(dfpEvent);
      }
    }, 3000);
  },
  _getPrebidConfig: function _getPrebidConfig(unitName, unitDivId) {
    var prebidConfig;

    if (window.config.adUnits[unitName] && window.config.adUnits[unitName].prebidConfig) {
      prebidConfig = window.config.adUnits[unitName].prebidConfig;
    }

    var unitNameWithNoNNN = unitName.replace(/_\d{1,2}$/, '_NNN');

    if (window.config.adUnits[unitNameWithNoNNN] && window.config.adUnits[unitNameWithNoNNN].prebidConfig) {
      prebidConfig = window.config.adUnits[unitNameWithNoNNN].prebidConfig;
    }

    if (prebidConfig && unitDivId) {
      prebidConfig = JSON.parse(JSON.stringify(prebidConfig));
      prebidConfig.code = unitDivId;
    }

    return prebidConfig;
  },
  _getPrebidConfigForSlots: function _getPrebidConfigForSlots(slots) {
    if (slots.length === 0) {
      console.warn('_getPrebidConfigForSlots called with empty slots parameter');
      return;
    }

    var prebidConfig = slots.filter(function (slot) {
      return slot.prebidConfig !== undefined;
    }).map(function (slot) {
      return slot.prebidConfig;
    });
    return prebidConfig;
  },
  _sendPrebidRequest: function _sendPrebidRequest(prebidUnitsConfig, sendAdserverRequest) {
    if (prebidUnitsConfig && prebidUnitsConfig.length > 0) {
      window.pbjs.que.push(function () {
        window.pbjs.adUnits = [];
        window.pbjs.addAdUnits(prebidUnitsConfig);
        window.pbjs.requestBids({
          bidsBackHandler: sendAdserverRequest
        });
      });
    } else {
      sendAdserverRequest();
    }
  },
  _sendAdserverRequest: function _sendAdserverRequest(dfpSlotsPortion, controlSendRequest) {
    // controlSendRequest.fp_hb_scripts_counter--;
    // if (controlSendRequest.fp_hb_scripts_counter > 0) return;
    if (controlSendRequest.adserverRequestSent) return;
    controlSendRequest.adserverRequestSent = true;
    var timer = [0];
    var intrrval = helper.config.adLoadDelay;
    googletag.cmd.push(function () {
      window.pbjs.que.push(function () {
        window.pbjs.setTargetingForGPTAsync();
      });
      /*
       * split array like this ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j']
       * into this
       * ['a', 'b', 'c']
       * ['d', 'e', 'f']
       * ['j', 'h', 'i']
       * ['j']
       */

      var dfpSlotsPortionSplitted = [];
      var inFeedSlots = [];
      var maxSizeOfSlotsCollection = window.config.adUnitsCopiesAmount;
      dfpSlotsPortion.forEach(function (slot) {
        if (/_[0-9]{1,2}$/.test(slot.getAdUnitPath())) {
          inFeedSlots.push(slot);
        } else {
          dfpSlotsPortionSplitted.push(slot);
        }
      });

      while (inFeedSlots.length > 0) {
        dfpSlotsPortionSplitted.push(inFeedSlots.splice(0, maxSizeOfSlotsCollection));
      } // console.log(dfpSlotsPortionSplitted);


      dfpSlotsPortionSplitted.forEach(function (part) {
        setTimeout(function () {
          if (typeof part.getName === "undefined") {
            googletag.pubads().refresh(part);
          } else {
            googletag.pubads().refresh([part]);
          } // typeof part.getName === "undefined" ? googletag.pubads().refresh(part) : googletag.pubads().refresh([part]);

        }, timer[0]);
        timer[0] = timer[0] + intrrval;
      });
    });
  },
  _refreshSlots: function _refreshSlots(dfpSlotsPortion, prebidUnitsConfig) {
    var that = this;
    var controlSendRequest = {
      fp_hb_scripts_counter: 2,
      adserverRequestSent: false
    };

    this._sendPrebidRequest(prebidUnitsConfig, function () {
      that._sendAdserverRequest(dfpSlotsPortion, controlSendRequest);
    });

    setTimeout(function () {
      that._sendAdserverRequest(dfpSlotsPortion, controlSendRequest);
    }, window.PREBID_TIMEOUT);
  },
  getHeightOfRenderedUnit: function getHeightOfRenderedUnit(dfpEvent) {
    // Is has duplicate in FooterWidget
    return document.getElementById(dfpEvent.slot.getSlotElementId()).querySelector('iframe').offsetHeight;
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var helper = __webpack_require__(0); // let ads = require('./ads');


module.exports = {
  isInited: false,
  init: function init(dfpEvent) {
    if (this.isInited) return;
    this.isInited = true;
    var that = this;
    var adPlacement = this.getAdPlacement(dfpEvent); // let creativeHeight = (dfpEvent.size) ? dfpEvent.size[1] : undefined;

    var creativeHeight = this.getHeightOfRenderedUnit(dfpEvent);
    helper.addClass(adPlacement, 'fixed-footer');
    if (creativeHeight) adPlacement.style.height = creativeHeight + 'px';
    var closeBtn = document.createElement('i');
    closeBtn.className = 'close-footer';
    helper.addEvent(closeBtn, 'click', function () {
      that.hide(undefined, adPlacement); // helper.addClass(adPlacement, 'fixed-footer-closed');
      // helper.removeClass(document.body, 'footer-widget-is-visible');
    });
    adPlacement.appendChild(closeBtn);
    this.fixIssueOnFacebookInAppBrowser(adPlacement);
  },
  show: function show(dfpEvent) {
    var adPlacement = this.getAdPlacement(dfpEvent); // let creativeHeight = (dfpEvent.size) ? dfpEvent.size[1] : undefined;

    this.updateHeight(dfpEvent, adPlacement);
    helper.removeClass(adPlacement, 'fixed-footer-closed');
    helper.addClass(adPlacement, 'fixed-footer-opened');
    helper.addClass(document.body, 'footer-widget-is-visible');
  },
  hide: function hide(dfpEvent, adPlacement) {
    if (!adPlacement) {
      adPlacement = this.getAdPlacement(dfpEvent);
    }

    helper.removeClass(adPlacement, 'fixed-footer-opened');
    helper.removeClass(document.body, 'footer-widget-is-visible');
    if (window.updateFooterHeightTimer) clearInterval(window.updateFooterHeightTimer);
  },
  updateHeight: function updateHeight(dfpEvent, adPlacement) {
    if (!adPlacement) {
      adPlacement = this.getAdPlacement(dfpEvent);
    }

    var creativeHeight = this.getHeightOfRenderedUnit(dfpEvent);
    if (creativeHeight) adPlacement.style.height = creativeHeight + 'px';
  },
  getAdPlacement: function getAdPlacement(dfpEvent) {
    var slot = dfpEvent.slot;
    var slotElementId = slot.getSlotElementId();
    var slotElement = document.getElementById(slotElementId);
    var adPlacement = slotElement.parentNode;
    return adPlacement;
  },
  fixIssueOnFacebookInAppBrowser: function fixIssueOnFacebookInAppBrowser(footer) {
    if (helper.isFacebookApp()) {
      var callback = function callback() {
        if (footer.className.indexOf('fixed-footer-opened') > -1) {
          var footerHeight = footer.offsetHeight;
          var windowHeight = window.innerHeight;
          var topToSet = windowHeight - footerHeight;
          footer.style.top = topToSet + 'px';
          footer.style.bottom = 'initial';
        }
      };

      callback();
      helper.addEvent(window, 'resize', callback);
      setInterval(callback, 1000);
    }
  },
  getHeightOfRenderedUnit: function getHeightOfRenderedUnit(dfpEvent) {
    // Is has duplicate in ads.js
    return document.getElementById(dfpEvent.slot.getSlotElementId()).querySelector('iframe').offsetHeight;
  }
};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = {
  _getParameterByName: function _getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },
  _createCookie: function _createCookie(name, value, hours) {
    if (hours) {
      var date = new Date();
      date.setTime(date.getTime() + hours * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else var expires = "";

    document.cookie = name + "=" + value + expires + "; path=/";
  },
  _readCookie: function _readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];

      while (c.charAt(0) == ' ') {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }

    return null;
  },
  storeUrlParams: function storeUrlParams(param_name) {
    var utm = this._getParameterByName(param_name);

    if (utm) this._createCookie('fp_' + param_name, utm);

    var cookies = this._readCookie('fp_' + param_name);

    if (cookies) window['fp_' + param_name] = cookies;
  }
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var helper = __webpack_require__(0);

module.exports = {
  init: function init(currentSlide) {
    var that = this;
    /*Create events*/

    helper.createEvents(['anotherSlideViewed']);
    this.currentSlideInViewNumber = undefined;
    this.currentSlide = currentSlide;
    window.fpEventsData = window.fpEventsData || {};
    window.fpEventsData.anotherSlideViewed = {
      slideInViewNumber: this.currentSlideInViewNumber
    };

    window.onpopstate = function (event) {
      if (event.state) {
        that.currentSlideInViewNumber = undefined;
        window.fpEventsData.anotherSlideViewed.slideInViewNumber = undefined;
      }
    };

    helper.addEvent(window, 'slideScrolling', function () {
      that._updateGlobalDataAndFireEventIfNeeded();
    });
  },
  _updateGlobalDataAndFireEventIfNeeded: function _updateGlobalDataAndFireEventIfNeeded() {
    var that = this;

    var numberOfHighestSeparatorWithinViewport = this._getNumberOfHighestSeparatorWithinViewport({
      currentSlide: that.currentSlide,
      distanceFromTopEdge: 100
    });

    if (numberOfHighestSeparatorWithinViewport === undefined) return;
    var slideInViewNumber = numberOfHighestSeparatorWithinViewport;

    if (this.currentSlideInViewNumber !== slideInViewNumber) {
      this.currentSlideInViewNumber = slideInViewNumber;
      window.fpEventsData.anotherSlideViewed.slideInViewNumber = slideInViewNumber;
      window.dispatchEvent(helper.getEventByName('anotherSlideViewed'));
    } // window.addEventListener('anotherSlideViewed', () => {console.log(window.fpEventsData.anotherSlideViewed)})

  },
  _getNumberOfHighestSeparatorWithinViewport: function _getNumberOfHighestSeparatorWithinViewport(params) {
    if (params.currentSlide === undefined) return;
    var separatorElements = params.currentSlide.querySelectorAll('.fp-slide-separator');
    if (separatorElements.length === 0) return;
    var separators = [];

    for (var i = 0; i < separatorElements.length; i++) {
      var separatorElement = separatorElements[i];
      separators.push({
        number: separatorElement.dataset.n,
        offsetTop: helper.getElementViewportOffset(separatorElement).top
      });
    }

    var separatorsBellowTopEdge = separators.filter(function (separator) {
      return separator.offsetTop > params.distanceFromTopEdge;
    });
    var heightsSeparator;
    var lowestSeparator;

    if (separatorsBellowTopEdge.length) {
      heightsSeparator = separatorsBellowTopEdge.reduce(function (prevSep, currSep) {
        if (prevSep) {
          return currSep.offsetTop < prevSep.offsetTop ? currSep : prevSep;
        }
      });
    } else {
      // find lowest one we have
      lowestSeparator = separators.reduce(function (prevSep, currSep) {
        if (prevSep) {
          return currSep.offsetTop > prevSep.offsetTop ? currSep : prevSep;
        }
      });
    }

    if (heightsSeparator) {
      return heightsSeparator.number;
    } else {
      return lowestSeparator.number;
    }
  }
};

/***/ })
/******/ ]);